import React, { useEffect } from 'react';

import { css } from '@betterment/samba-styled-system/css';

export interface CapitalizeWebviewContentProps {
  webviewUrl: string;
}

export const CapitalizeWebviewContent: React.FC<CapitalizeWebviewContentProps> = ({ webviewUrl }) => {
  useEffect(() => {
    window.addEventListener('message', handleWindowEvent);
    return () => window.removeEventListener('message', handleWindowEvent);
  }, []);

  return (
    <iframe
      className={css({
        width: '100%',
        height: '500px',
        border: 'none',
      })}
      src={webviewUrl}
      title="Capitalize rollover webview"
    />
  );
};

interface EventData {
  type: string;
}

function handleWindowEvent(event: MessageEvent<EventData>) {
  const { data } = event;

  // eslint-disable-next-line no-alert
  window.alert(`Received window event: ${JSON.stringify(data)}`);

  if (data?.type === 'onCreateRothDestinationNeeded') {
    window.console.log('onCreateRothDestinationNeeded', data);
  }

  if (data?.type === 'onCreateTradDestinationNeeded') {
    window.console.log('onCreateTradDestinationNeeded', data);
  }

  if (data?.type === 'onCapitalizeRolloverCreated') {
    window.console.log('onCapitalizeRolloverCreated', data);
  }

  if (data?.type === 'onCapitalizeRolloverSubmittedV2') {
    window.console.log('onCapitalizeRolloverSubmittedV2', data);
  }

  if (data?.type === 'onError') {
    window.console.error('Capitalize webview error', data);
  }
}

export default CapitalizeWebviewContent;
